import React from 'react';
import './StaticPages.css';

function MaintenanceError() {
  return (
    <div className="page-container" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '80vh'}}>
      <div className="glass-card animate-up" style={{textAlign: 'center', maxWidth: '600px', padding: '50px', borderTop: '4px solid #ff375f'}}>
        
        <i className="fa-solid fa-person-digging" style={{fontSize: '4rem', color: '#ff375f', marginBottom: '20px'}}></i>
        
        <h1 style={{fontSize: '2.5rem', marginBottom: '15px', color: '#fff'}}>Under Maintenance</h1>
        
        <p style={{color: '#c9d1d9', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '30px'}}>
          DevTracker is currently undergoing scheduled platform upgrades. 
          Some or all public services are temporarily disabled while we apply critical infrastructure changes.
        </p>
        
        <div style={{background: 'rgba(255,55,95,0.1)', padding: '15px', borderRadius: '8px', color: '#ff375f', display: 'inline-flex', alignItems: 'center', gap: '10px'}}>
          <i className="fa-solid fa-clock"></i> We'll be right back shortly.
        </div>

      </div>
    </div>
  );
}

export default MaintenanceError;
